module.exports = __webpack_public_path__ + "img/sure-mobile.add85a1a.svg";